export default __webpack_public_path__ + "static/media/3.24b1a320.mp3";